import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'
import { GenericInputs } from './GenericInputs'
import styles from './GenericModal.module.css'

export const GenericGrid = ({
  campos = [],
  values = {},
  onAddItem,
  onRemoveItem,
  onChangeItem,
  onCopyField,
  errores = {},
  editMode
}) => {
  const grid = campos.filter((g) => g.isGrid)
  const filas = values?.grilla ?? []

  if (grid.length === 0) {
    return null
  }

  return (
    <>
      {filas.map((fila, filaIndex) => (
        <div key={filaIndex} className={styles.lista}>
          <div className={styles.filaContainer}>
            {grid.map((content) => {
              const { name, label, isFullWidth, isGrid, copy, type } = content
              const value = fila?.[name] ?? ''
              return (
                <div
                  key={name}
                  className={`${styles.inputs} ${
                    isFullWidth ? styles.fullWidth : styles.partialWidthGrid
                  } ${type === 'number' ? styles.numberField : ''}`}
                >
                  {isGrid && (
                    <>
                      {filaIndex === 0 && (
                        <div className={styles.firstLine}>
                          <label htmlFor={`${name}-${filaIndex}`}>{label}</label>
                          {copy && (
                            <Button
                              variant="light"
                              className={styles.copyButton}
                              onClick={() => onCopyField(name, value)}
                              title="Copiar para todas las filas"
                            >
                              <i className=" bi bi-file-earmark-arrow-down btnIconColor btn-sm"></i>
                            </Button>
                          )}
                        </div>
                      )}
                      <GenericInputs
                        key={content.name}
                        content={content}
                        value={value}
                        onChange={onChangeItem}
                        errores={errores}
                        editMode={editMode}
                        filaIndex={filaIndex}
                      />
                    </>
                  )}
                </div>
              )
            })}

            {filaIndex !== 0 && (
              <>
                <Button
                  variant="light"
                  className={styles.btnBackground}
                  onClick={() => onRemoveItem(filaIndex)}
                  title="Eliminar fila"
                >
                  <i className="bi bi-trash-fill btnIconColor btn-sm"></i>
                </Button>
              </>
            )}
          </div>
        </div>
      ))}

      {filas.length > 0 && (
        <div className={styles.addContainer}>
          <Button size="sm" className="btn-info" onClick={onAddItem}>
            +
          </Button>
        </div>
      )}
    </>
  )
}

GenericGrid.propTypes = {
  campos: PropTypes.shape({
    type: PropTypes.oneOf(['text', 'email', 'date', 'number', 'password', 'select']),
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    label: PropTypes.string.isRequired,
    isFullWidth: PropTypes.bool.isRequired,
    isEditable: PropTypes.bool.isRequired,
    isGrid: PropTypes.bool.isRequired,
    copy: PropTypes.bool,
    options: PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.string.isRequired,
      key: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    })
  }),
  values: PropTypes.object,
  onChange: PropTypes.func,
  errores: PropTypes.object,
  editMode: PropTypes.bool,
  onAddItem: PropTypes.func,
  onRemoveItem: PropTypes.func,
  onChangeItem: PropTypes.func,
  onCopyField: PropTypes.func
}
